import { TableCell, TableRow, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function GradingListScalesItem({ gradeScale }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = '/settings/grading/scales'

  return (
    <TableRow hover>
      <TableCell>
          {gradeScale.name}
      </TableCell>
      <TableCell>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={() => navigate(`${basePath}/${gradeScale?.id}`)}
        >
          {t('More')}
        </Button>
      </TableCell>
    </TableRow>
  )
}
